import React, { useContext, useEffect, useState } from "react";
import { InputContext } from "../../../shared/contexts/InputContext";
import classes from "./PartTimeServiceInputs.module.css";

const PartTimeServiceInput = ({min_date, max_date}) => {
  const { inputs, updateInput } = useContext(InputContext);
  const [partTimeService, setPartTimeService] = useState(
    inputs.memberInfo.partTimeServicePrePartRet
  );
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [percentage, setPercentage] = useState("");
  const [error, setError] = useState(null);

  const addService = (event) => {
    event.preventDefault();  

    const newService = {
      FROM: startDate,
      TO: endDate,
      PROPORTION: percentage,
    };

    if (startDate === "") {
      setError("Start date needs an entry.");
      return;
    }   

    if ((endDate !=="") && (new Date(endDate) < new Date(startDate))) {
      setError("End date cannot be before start date.");
      return;
    }

    if (percentage <= 0 || percentage >= 99) {
      setError("Percentage must be greater than 0 and less than 99.");
      return;
    }

    console.log(min_date)
    console.log(max_date)
    console.log(new Date(endDate))
    console.log(new Date(startDate))
    if(new Date(endDate) > max_date) {
      setError("End date cannot be after partial retirement date");
      return
    }

    if(new Date(startDate) < min_date) {
      setError("Start date cannot be before joining date");
      return
    }

    const isOverlap = (service1, service2) => {
      const start1 = new Date(service1.FROM);
      const end1 = new Date(service1.TO);
      const start2 = new Date(service2.FROM);
      const end2 = new Date(service2.TO);
      //let check =  start1 <= end2 && start2 <= end1
      let check =  (start2 >= start1 && start2 <= end1) || (end2 >= start1 && end2 <= end1)
      return check;
    };

    for (let i = 0; i < partTimeService.length; i++) {
      console.log({'s1': partTimeService[i], 's2': newService})
      if (isOverlap(partTimeService[i], newService)) {
        setError("This entry overlaps with an existing part-time service.");
        return;
      }
    }

    const updatedPartTimeService = [...partTimeService, newService];

    updatedPartTimeService.sort((a, b) => new Date(a.From) - new Date(b.From));

    setPartTimeService(updatedPartTimeService);

    setStartDate("");
    setEndDate("");
    setPercentage("");
    setError(null);
  };

  const removeService = (event, index) => {
    event.preventDefault();  
    setPartTimeService(partTimeService.filter((_, i) => i !== index));
  };

  useEffect(() => {
    updateInput("memberInfo", "partTimeServicePrePartRet", partTimeService);
  }, [partTimeService]);

  return (
    <div className={classes.service_container}>
      <h3>Part-time working history</h3>

      <p>
        Enter details of any part-time working periods you have had up to the 
        date of partial retirement. If you do not have any periods of part-time 
        working click 'Next'. You can enter details of your expected working 
        pattern post-partial retirement on the next page
      </p>
      <p>
        In the 'Percentage' field, specify a number between 0 and 100 that 
        reflects the percentage of a full-time schedule you have worked over 
        each period. For instance, working 29.6 hours (4 days) per week when 
        the full-time equivalent is 37 hours (5 days) per week corresponds 
        to an 80% part-time rate, so you would enter '80' in the percentage field.
      </p>
      <p>
        Any time outside of the periods you input will be
        considered full-time service by default.
      </p>

      <p>
        If you are currently part-time and expect to remain so until partial retirement, do not enter an end date in your period.
      </p>
      {error && <p style={{ color: "red" }}>{error}</p>}
      <div className={classes.subContainer}>
        <div className={classes.inputContainer}>
          <div className={classes.label_input}>
            <label>Start Date:</label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className={classes.input}
            />
          </div>
          <div className={classes.label_input}>
            <label>End Date:</label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className={classes.input}
            />
          </div>
          <div className={classes.label_input}>
            <label>Percentage (%):</label>
            <input
              type="number"
              value={percentage}
              onChange={(e) => setPercentage(e.target.value)}
              min={1}
              step={1}
              max={99}
              className={classes.input}
            />
          </div>
        </div>
        <button onClick={(e) => addService(e)}>Add Service</button>
      </div>
      <table>
        <thead>
          <tr>
            <th className={classes.leftColumn}></th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Proportion</th>
            <th className={classes.rightColumn}></th>
          </tr>
        </thead>
        <tbody>
          {partTimeService.map((service, i) => (
            <tr key={i}>
              <td className={classes.leftColumn}>{i + 1}.</td>
              <td>{service.FROM === "" ? "-" : new Date(service.FROM).toLocaleDateString("en-GB")}</td>
              <td>{service.TO === "" ? "-" : new Date(service.TO).toLocaleDateString("en-GB")}</td>
              <td>{service.PROPORTION}%</td>
              <td className={classes.rightColumn}>
                <button onClick={(e) => removeService(e, i)}>X</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PartTimeServiceInput;
